module.exports = __webpack_public_path__ + "static/media/drawing_mask.81bbe5d3.png";